
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import { AUTH_LOG_USER_OUT, SHOW_PROFILE_DIALOG } from '@/store/action-types'
import { Action } from 'vuex-class'
import { UserDropDownItem, UserDropDownList } from '@/types'
import { CurrentUser } from '@/model/CurrentUser'
import { USER_LOGGED_IN } from '@/store/getter-types'

@Component
export default class UserDropDown extends Vue {
  private links: UserDropDownList = [
    {
      name: 'toolbarPage.profileLabel',
      code: "profile",
      icon: "fa-user-circle"
    },
    {
      name: 'toolbarPage.logoutLabel',
      code: "logout",
      icon: "fa-power-off"
    }
  ]

  @Action(AUTH_LOG_USER_OUT) logUserOut!: { (): Promise<void> }
  @Action(SHOW_PROFILE_DIALOG) showProfileDialog!: { (payload: boolean): Promise<void> }

  get userLoggedIn(): CurrentUser{
    return this.$store.getters[USER_LOGGED_IN]
  }

  onClickItem ( item: UserDropDownItem): void {

    if(item && item.code == "logout")
    {
      this.logUserOut()
      this.$router.push('/login')
    } else if(item && item.code == "profile") {
      this.showProfileDialog(true)
    }

    this.$emit('closeMenu')
  }
}
